/**
 * HC Packaging Plus quote mode.
 * - After Shopify confirms the order request (contact form posted successfully), empties the cart
 *   and reloads the cart page with ?hc_request=sent. Nothing is cleared if the submit failed.
 * - On ?hc_request=sent, reveals the layout-level confirmation banner.
 * - If the form came back with errors, moves focus to them.
 */
const SENT_PARAM = 'hc_request';

/** @returns {string} */
function cartUrl() {
  // @ts-ignore Theme is a global defined in snippets/scripts.liquid
  return window.Theme?.routes?.cart_url || '/cart';
}

async function clearCartAfterSuccess() {
  if (!document.querySelector('[data-hc-quote-sent]')) return;
  if (sessionStorage.getItem('hcQuoteClearing') === location.href) return;

  try {
    sessionStorage.setItem('hcQuoteClearing', location.href);
  } catch {
    // Storage unavailable: the URL change below still prevents a loop.
  }

  try {
    const response = await fetch(`${cartUrl()}/clear.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
  } catch {
    // Keep the cart if clearing failed; the request itself was already sent.
    return;
  }

  const target = new URL(cartUrl(), location.origin);
  target.searchParams.set(SENT_PARAM, 'sent');
  location.replace(target.toString());
}

function showSentBanner() {
  const params = new URLSearchParams(location.search);
  if (params.get(SENT_PARAM) !== 'sent') return;

  const banner = document.querySelector('[data-hc-quote-status]');
  const message = document.querySelector('[data-hc-quote-status-message]');
  if (!(banner instanceof HTMLElement) || !(message instanceof HTMLElement)) return;

  banner.hidden = false;
  message.textContent = message.dataset.message || '';

  // Drop the flag from the address bar so a refresh does not repeat the message.
  params.delete(SENT_PARAM);
  const query = params.toString();
  history.replaceState(null, '', `${location.pathname}${query ? `?${query}` : ''}${location.hash}`);
}

function focusErrors() {
  const errors = document.querySelector('[data-hc-quote-errors]');
  if (!(errors instanceof HTMLElement)) return;
  errors.scrollIntoView({ block: 'center' });
  errors.focus({ preventScroll: true });
}

function init() {
  showSentBanner();
  focusErrors();
  clearCartAfterSuccess();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
